import Icon from './icon';
import defaultsDeep from 'lodash-es/defaultsDeep';
import get from 'lodash-es/get';

export default class Callout extends Icon {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);

    this.addApi(this, 'text', () =>
      this._checkDataOption('text', get(this._controlOptions,'text',get(this._controlOptions, 'panel.HTML', ''))), {
      formatter: 'textFormatter'
    });

    this.addApi(this, 'showCallout', () => this._controlOptions.panel && this._controlOptions.panel.initialState == 'visible');
  }

  onReady(){
    var me = this;
    const control = (this.options.attachTo !== 'icon' && this.parentControl)? this.parentControl : this;
    if(this.options.showOn=='click'){
      control.addTrigger('click',(event,ctrl,cmp,anchor,data)=>me.toggle(event,me,cmp,anchor,data));
    }else if(this.options.showOn=='hover'){
      control.addTrigger('mouseleave,mouseenter',(event,ctrl,cmp,anchor,data)=>me.toggle(event,me,cmp,anchor,data));
      if(this.options.attachTo=='pointer'){
        control.addTrigger('mousemove',(event,ctrl,cmp,anchor,[ev])=>{
          if(this.showCallout){
            this.ev = ev;
            this.render();
          }
        });
      }
    }

    if(this.options.hideOnClickOutside){
      this.addTrigger('clickOutside',(event,ctrl,cmp,anchor,data)=>me.toggle(event,me,cmp,anchor,data));
    }

    super.onReady();
  }

  renderElement() {
    const control = this;
    const options = this._controlOptions;
    const design = get(control,['options','lookAndFeel','controlsDesign'],'classic');
    // console.log('renderElement', control, options, instance, path);
    defaultsDeep(options, {
      showOn:!options.attachTo||options.attachTo=='icon'?'click':'hover',
      attachTo: 'icon',
      hideOnClickOutside: options.showOn!=='scripted',

      url: design=='classic'?'themes/css/img/controls/callout.png':'themes/css/img/controls/callout-flat.png',
      style: {
        normal: {
          height: '16px',
          width: '16px',
          cursor: 'pointer',
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 4px rgba(0,0,0,0.5))',
          zIndex: 100500,
        },
      },
      closeButton: {
        visible: true,
        label: {
          text: 'Button',
          visible: false,
        },
        type: 'button',
        value: {
          defaultValue: '',
          type: '',
        },
        style: {
          normal: {
            height: '12px',
            top: '4px',
            width: '12px',
            right: '4px',
            left: 'auto',
            boxShadow: '0 -2px 2px ${schemeShade} inset,  0 2px 3px rgba(255,255,255,0.5) inset',
            borderWidth: '1px',
            padding: '0',
          },
          hover: {
            boxShadow: '0 -2px 2px ${schemeShade} inset,  0 2px 3px #ffffff inset',
          },
        },
        icon: {
          url:
            "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FFFFFF' d='M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z' /%3E%3C/svg%3E",
          stretch: 'contain',
          style: {
            normal: {
              margin: '0px',
            },
          },
        },
      },
      panel: {
        type: 'panel',
        $renderOnTop: true,
        initialState: 'hidden',
        position: 'top',
        offset: 16,
        pointer: {
          visible: options.attachTo!=='pointer',
        },
        style: {
          normal: {
            // transition: 'opacity 0.5s ease',
            position: 'absolute',
            width: 'auto',
            height: 'auto',
            minWidth: '64px',
            borderColor: 'rgba(0,0,0,0.5)',
            borderWidth: '1px',
            borderRadius: '6px',
            boxShadow: 'none',
            backgroundColor: '#FFFFFF',
            color: '#000000',
            transition:'opacity 300ms ease-in-out 0ms',
            zIndex:100500
          },
        },
      },
    });

    if(options.hideOnMoveOutside===undefined){
      options.hideOnMoveOutside = options.showOn=='hover';
    }

    _.assign(options.panel.style.normal, this.getPanelPosition(options.panel));

    if (control.showCallout === undefined) {
      control.showCallout = !control.isLayoutMode && options.panel.initialState == 'visible';
    }

    // if (typeof control.text != 'string') {
    //   control.text += '';
    // }

    options.panel.HTML = control.text+'';

    if (control.showCallout) {
      _.assign(options.panel.style.normal, {
        pointerEvents:'auto!important',
        opacity:'1!important',
      });
    } else {
      _.assign(options.panel.style.normal, {
        pointerEvents:'none!important',
        opacity:'0!important',
        left:'-5000px',
        top:'-5000px',
      });
    }        

    if (!control.isLayoutMode) {
      options.controls = [options.panel];
      if (options.panel.pointer.visible) {
        const pointer = _.cloneDeep(options.panel);
        _.assign(pointer.style.normal, this.getPointerPosition(pointer));
        delete pointer.pointer;
        delete pointer.controls;
        delete pointer.formatter;
        delete pointer.HTMLFormatter;
        delete pointer.triggers;
        delete pointer.events;
        pointer.HTML = '';
        pointer.style.normal.width = pointer.offset + 'px';
        pointer.style.normal.height = pointer.offset + 'px';
        pointer.style.normal.padding = 0;
        pointer.style.normal.borderRadius = 0;
        pointer.style.normal.borderWidth = `calc(${pointer.style.normal.borderWidth} + 1px)`;
        pointer.style.normal.minWidth = 0;
        pointer.style.normal.minHeight = 0;
        options.controls.push(pointer);
      }

      if (options.closeButton.visible) {
        const closeButton = _.cloneDeep(options.closeButton);
        closeButton.style.normal.display = options.panel.style.normal.display;
        // Buttons dispatch the legacy single-trigger API (button.js fires
        // control.options.trigger on DOM click) — not _controlOptions.triggers.click.
        // Use `trigger` so the click actually closes the callout.
        closeButton.trigger = function(opts, instance, btnControl, path, ev) {
          if (ev && ev.stopPropagation) { ev.stopPropagation(); }
          control.showCallout = false;
          control.render();
        };

        options.panel.controls = [closeButton];
      } else {
        options.panel.controls = [];
      }
    } else {
      options.controls = [];
    }

    if(options.attachTo!=='icon'){
      options.style.normal.width=0;
      options.style.normal.height=0;
    }

    return super.renderElement();
  }

  toggle(event,me=this,cmp=me.instance,anchor,[ev]=[]){
    // console.log('callout:',event);
    const myEl = me.el;
    const parentEl = me.parentControl && me.parentControl.el;
    const hit = ev===undefined
    || (myEl && (ev.target === myEl || ev.target === myEl.firstChild))
    || ( me.options.attachTo!=='icon'
    && parentEl
    && ( ev.target === parentEl
        || ev.target === parentEl.firstChild)
    );
      
    if(hit){
      if(me.options.group){
        const current = me.instance.calloutGroups[me.options.group];
        if(current && current!==me.path){
          me.instance.controls[current].toggle(event=='click'&&event||'mouseleave');
        }
      }
    }

    if(event == 'clickOutside' || hit){

      if(event=='click'){
        me.showCallout = !me.showCallout;        
      }else if(event=='mouseenter'){
        me.showCallout = true;
        if(me.options.hideAfter){
          me._hideTimer = setTimeout(()=>{
            if(me.showCallout){
              me.showCallout=false;
              me.render();
              delete me._hideTimer;
            }
          },me.options.hideAfter*1000);
        }
      }else{
        if(event=='clickOutside'&&me.options.hideOnClickOutside
          ||event=='mouseleave'&&me.options.hideOnMoveOutside){

          me.showCallout = false;
          if(me._hideTimer){
             clearTimeout(me._hideTimer);
             delete me._hideTimer;
          }

        }
      }

      if(me.options.group){
        if(me.showCallout){
          me.instance.calloutGroups[me.options.group] = me.path;
        }else if(me.instance.calloutGroups[me.options.group] == me.path){
          me.instance.calloutGroups[me.options.group] = null;
        }
      }

      if(ev && event !== 'clickOutside') {ev.stopPropagation();}

      if(ev && event!=='mouseleave'){
        me.ev = ev;        
      }

      if(!me.showCallout){
        setTimeout(()=>{
          me.render();        
          me.raiseEvent('isExpanded',{value:me.showCallout,oldValue:!me.showCallout},ev);
        },100)
      }else{
        me.render();        
        me.raiseEvent('isExpanded',{value:me.showCallout,oldValue:!me.showCallout},ev);
      }
    }
  }

  

  getPanelPosition({ position, offset }) {
    
    let parent = this.options.attachTo !== 'icon'? this.parentControl.getAbsoluteRect() : this.getAbsoluteRect();
    // console.log('panel position',parent,this.ev);
    if(this.options.attachTo =='pointer' && this.ev){
      parent = this.getEventPosition(this.ev);
    }

    switch (position) {
      case 'top':
        return {
          top: 'auto',
          // top: `calc(1${this.top} + ${offset}px)`,
          right: 'auto',
          bottom: `calc(100% - ${parent.top}px + ${offset}px)`,
          // bottom: `auto`,
          left: `${parent.left + parent.width/2}px`,
          // left: '50%',
          transform: 'translateX(-50%)',
        };
      case 'right':
        return {
          top: `${parent.top + parent.height/2}px`,
          right: 'auto',
          bottom: 'auto',
          left: `calc(${parent.left+parent.width+offset}px)`,
          transform: 'translateY(-50%)',
        };
      case 'bottom':
        return {
          top: `${parent.top+parent.height + offset}px`,
          right: 'auto',
          bottom: 'auto',
          left: `${parent.left + parent.width/2}px`,
          transform: 'translateX(-50%)',
        };
      case 'left':
        return {
          top: `${parent.top + parent.height/2}px`,
          right: `calc(100% - ${parent.left}px + ${offset}px)`,
          bottom: 'auto',
          left: 'auto',
          transform: 'translateY(-50%)',
        };
      default:
        return {
          //change nothing in user definition
        };
    }
  }

  getPointerPosition(options) {
    let parent = this.options.attachTo !== 'icon'? this.parentControl.getAbsoluteRect() : this.getAbsoluteRect();
    if(this.options.attachTo =='pointer' && this.ev){
      parent = this.getEventPosition(this.ev);
    }

    const position = options.position;
    const offset = options.offset;
    let borderWidth = options.style.normal.borderWidth;
    if (!borderWidth || borderWidth == '0' || borderWidth == '0px' || borderWidth == '0%') {
      borderWidth = '1px';
    }

    let sq = Math.sqrt(2 * offset * offset) / 2;
    let scale = offset / sq;

    switch (position) {
      case 'top':
        return {
          clipPath: 'polygon(0% 100%, 100% 0%, 100% 100%)',
          bottom: `calc(100% - ${parent.top}px + ${offset / 2}px + ${borderWidth})`,
          left: `${parent.left + parent.width/2}px`,
          transform: `translateX(-50%) scaleX(0.5) scaleY(${scale}) rotate(45deg)`,
        };
      case 'right':
        return {
          clipPath: 'polygon(0% 0%, 100% 100%, 0% 100%)',
          top: `${parent.top + parent.height/2}px`,
          left: `calc(${parent.left + parent.width + offset / 2}px + ${borderWidth})`,
          transform: `translateY(-50%) scaleX(${scale}) scaleY(0.5) rotate(45deg)`,
        };
      case 'bottom':
        return {
          clipPath: 'polygon(0% 100%, 0% 0%, 100% 0%)',
          top: `calc(${parent.top + parent.height + offset / 2}px + ${borderWidth})`,
          left: `${parent.left + parent.width/2}px`,
          transform: `translateX(-50%) scaleX(0.5) scaleY(${scale}) rotate(45deg)`,
        };
      case 'left':
        return {
          top: `${parent.top + parent.height/2}px`,
          clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%)',
          right: `calc(100% - ${parent.left}px + ${offset / 2}px + ${borderWidth})`,
          transform: `translateY(-50%) scaleX(${scale}) scaleY(0.5) rotate(45deg)`,
        };
      default:
        return {
          display: 'none',
        };
    }
  }
}
